<template>
  <div id="home">
    <div class="home-top">
      <div class="header">
        <div class="top">
          <div class="logo">
            <img v-if="simInfo.flowRatePool == '联通' || simInfo.flowRatePool == '乐语'" src="@/assets/cucc.png" alt="" />
            <img v-else-if="simInfo.flowRatePool == '电信'" src="@/assets/ctcc.png" alt="" />
            <img v-else-if="simInfo.flowRatePool == '移动' || simInfo.flowRatePool == '移动接口'" src="@/assets/cmcc.png"
              alt="" />
            <img v-else src="@/assets/kairan.jpg" alt="" />
          </div>
          <div class="top-r">
            <div class="user-name">{{ simInfo.virtualNo }}</div>
            <van-button round type="info" size="small" color="#64a9ff" @click="loginOut()"><van-icon name="exchange"
                style="margin-right:4px;" /> 换号</van-button>
          </div>
        </div>
        <div class="fs-center">
          <div class="fs-left">{{ isAuthName }}</div>
          <div class="divider"></div>
          <div class="fs-meddle">{{ simInfo.cardStateName }}</div>
          <div class="fs-right" @click="updateStateRateFlow()"><van-button round type="info" size="small"
              color="#64a9ff"><van-icon name="replay" style="margin-right:4px;" /> 刷新</van-button></div>
        </div>
        <div class="top-taocan">
          <div class="taocan-item b_r">
            <div class="time">{{ simInfo.endTimeString }}</div>
            <div class="time-name">套餐到期时间</div>
          </div>
          <div class="taocan-item b_r">
            <div class="time"> {{ fluxMtoG(simInfo.usedFlowRate) }}</div>
            <div class="time-name">已用流量(GB)</div>
          </div>
          <div class="taocan-item">
            <div class="time">{{ fluxMtoG(simInfo.flowRate - simInfo.usedFlowRate) }}</div>
            <div class="time-name">剩余流量(GB)</div>
          </div>
        </div>
      </div>
      <div class="menu-nav">
        <div class="left" @click="toRecharge1()">
          <img src="@/assets/user/123.png" alt="" class="menu-icon">
          <div class="name">一键复机</div>
        </div>
        <div class="left" @click="toRecharge2()">
          <img src="@/assets/user/126.png" alt="" class="menu-icon">
          <div class="name">一键停机</div>
        </div>
        <div class="left" @click="pkgListVisible = true">
          <img src="@/assets/user/124.png" alt="" class="menu-icon">
          <div class="name">我的套餐</div>
        </div>
        <div class="left" @click="toLog()">
          <img src="@/assets/user/125.png" alt="" class="menu-icon">
          <div class="name">订购记录</div>
        </div>
      </div>
      <div class="content">
        <div class="content-items" v-for="item in dataList" :key="item.id">
          <div class="items-name">{{ item.packageName }}</div>
          <div class="items-flex">
            <div class="fl_l">{{ (item.salePriceRmb).toFixed(2) }}<span>元</span></div>
            <div classs="fl_r">
              <van-button round type="info" size="small" color="#fca842" @click="handleClick(item)">立即订购</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog v-model="appshowimg" title="关注公众号" confirmButtonColor="#86de6b" confirmButtonText="知道了">
      <img style="width: 100%" :src="newHomeImg2" />
      <div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">长按即可识别</div>
    </van-dialog>
    <van-dialog v-model="timeShow" showCancelButton title="请选择套餐生效时间" confirmButtonText="确认" @confirm="confirm">
      <van-radio-group v-model="radio">
        <van-radio name="0">
          立即生效
          <span>{{ nowMonthDay }} </span>
        </van-radio>
        <van-radio name="1" v-if="isNaturalMonth">
          次月生效
          <span>{{ nextMonthDay }} </span>
        </van-radio>
      </van-radio-group>
    </van-dialog>



    <van-popup v-model="pkgListVisible" closeable position="bottom" style="min-height: 35%; max-height: 75%">
      <p style="text-align: center; font-weight: bold;">本月套餐</p>
      <div class="pkgList">
        <template v-if="simInfo.simPackageList.length > 0">
          <ul>
            <li v-for="item in simInfo.simPackageList" :key="item.id">
              <p><span>套餐名称：</span> {{ item.packageName }}</p>
              <div>
                <p> <span>生效时间：</span> {{ item.startTime }}</p>
                <p v-if="new Date(getDateByTimeStr(item.endTime)[0], getDateByTimeStr(item.endTime)[1], getDateByTimeStr(item.endTime)[2], getDateByTimeStr(item.endTime)[3], getDateByTimeStr(item.endTime)[4], getDateByTimeStr(item.endTime)[5]) < new Date()"
                  style="color: red;"><span>过期时间：</span> {{ item.endTime }}</p>
                <p v-else><span>过期时间：</span> {{ item.endTime }}</p>
              </div>
            </li>
          </ul>
        </template>
        <h3 v-else style="color: red">未订购可用套餐</h3>
      </div>
      <p style="text-align: center; font-weight: bold;">次月套餐</p>
      <div class="pkgList">
        <template v-if="simInfo.simNextPackageList.length > 0">
          <ul>
            <li v-for="item in simInfo.simNextPackageList" :key="item.id">
              <p> <span>套餐名称：</span>{{ item.packageName }}</p>
              <div>
                <p><span>生效时间：</span> {{ item.startTime }}</p>
                <p v-if="new Date(getDateByTimeStr(item.endTime)[0], getDateByTimeStr(item.endTime)[1], getDateByTimeStr(item.endTime)[2], getDateByTimeStr(item.endTime)[3], getDateByTimeStr(item.endTime)[4], getDateByTimeStr(item.endTime)[5]) < new Date()"
                  style="color: red;"><span>过期时间：</span> {{ item.endTime }}</p>
                <p v-else><span>过期时间：</span> {{ item.endTime }}</p>
              </div>
            </li>
          </ul>
        </template>
        <h3 v-else style="color: red">未订购次月套餐</h3>

      </div>

    </van-popup>
    <Checkstand :checkstandStyle="checkstandStyle" :dataToPay="dataToPay" :price="price" :typeStyle="typeStyle" />

  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import Checkstand from "@/components/Checkstand";
export default {
  components: {
    Checkstand
  },
  name: "home",
  data() {
    return {
      newHomeImg2: localStorage.getItem('newHomeImg2'),
      pkgListVisible: false,
      isAuthName: "未实名/未知",
      simInfo: {
        simPackageList: [],
        simNextPackageList: []
      },
      appshowimg: false,
      radio: '0',
      isAdmin: '',
      thisCucc: 0,
      isNextMonth: '0',
      nextMonthDay: '',
      nowMonthDay: '',
      isNaturalMonth: false,
      timeShow: false,
      ctccJieAuth: false,
      dataList: [],
      //收银台
      checkstandStyle: {
        height: '50%',
        transition: '0.8s !important',
      },
      dataToPay: {},
      price: 0,
      typeStyle: 1, //流量充值入口为1
      shebeiLogin: localStorage.getItem("shebeiLogin"),
      wxHeadImg: localStorage.getItem("wxHeadImg"),

      cuccAuthShow: false,
      ctccAuthShow: false,
      cmccAuthShow: false,
      qianhaiSHow: false,
      leyuAuthShow: false,
      cmccXxtx: false,
      otherAuth: false,
      ctcc5GAuth: false,
      otherUrl: '',
      guangdianAuth: false,
      ctccPhoneAuth: false,


    };

  },
  computed: {},
  methods: {
    getUserSimInfo() {
      wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then((res) => {
        if (res.data.code == 200) {
          this.simInfo = res.data.data;
          let result = res.data.data;
          if (result.flowRatePool == "电信") {
            this.ctccAuthShow = true;
          } else if (result.flowRatePool == "电信接口") {
            this.ctccJieAuth = true;
          } else if (result.flowRatePool == "联通") {
            this.cuccAuthShow = true;
          } else if (result.flowRatePool == "前海") {
            this.qianhaiSHow = true;
          } else if (result.flowRatePool == "移动") {
            this.cmccAuthShow = true;
          } else if (result.flowRatePool == "乐语") {
            this.leyuAuthShow = true;
          } else if (result.flowRatePool == "移动接口") {
            this.cmccXxtx = true;
          } else if (result.flowRatePool == "5G电信") {
            this.ctcc5GAuth = true;
          } else if (result.flowRatePool == '广电') {
            this.guangdianAuth = true;
          } else if (result.flowRatePool == '电信号卡') {
            this.ctccPhoneAuth = true;
          } else {
            this.otherUrl = result.flowRatePool;
            this.otherAuth = true;
          }
          wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: this.simInfo.intoNo, }, "post").then((res) => {
            if (res.data.code == 200) {
              this.isAuthName = "已实名";
              if (this.newHomeImg2 && this.newHomeImg2.length > 2) {
                this.appshowimg = true;
              }
            } else if (res.data.code == 302) {
              this.isAuthName = "请先购买套餐";
            } else {
              Dialog.confirm({
                title: "实名提醒",
                message: "根据工信部要求，当卡完成实名后 才可激活正常使用。请您根据指示前往实名(已实名请忽略)",
                confirmButtonText: "前往实名",
                cancelButtonText: "暂不实名",
              })
                .then(() => {
                  if (this.cmccXxtx == true) {
                    wxRequest(
                      "wxAuth/cmcc/auth",
                      { iccid: this.$store.state.iccid },
                      "post"
                    ).then((res) => {
                      if (res.data.code == "200") {
                        window.location.href = res.data.data;
                      } else {
                        Dialog.alert({
                          title: "提示",
                          message: res.data.message,
                        });
                      }
                    });
                  } else if (this.ctccAuthShow == true) {
                    this.$router.push({
                      path: "/user/ctccAuth",
                      query: { realNameCard: 1 },
                    });
                  } else if (this.cuccAuthShow == true) {
                    window.location.href = "http://wx.wzyw.cc/#/user/cuccAuth";
                  } else if (this.cmccAuthShow == true) {
                    this.$router.push({
                      path: "/user/cmccAuth",
                      query: { realNameCard: 1 },
                    });
                  } else if (this.ctccJieAuth == true) {
                    wxRequest(
                      "wxAuth/ctcc/to/auth",
                      { iccid: this.$store.state.iccid },
                      "post"
                    ).then((res) => {
                      if (res.data.code == "200") {
                        window.location.href = res.data.data;
                      } else {
                        Dialog.alert({
                          title: "提示",
                          message: res.data.message,
                        });
                      }
                    });
                  } else if (this.ctcc5GAuth == true) {
                    wxRequest(
                      "wxAuth/ctcc/to/5G/auth",
                      { iccid: this.$store.state.iccid },
                      "post"
                    ).then((res) => {
                      if (res.data.code == "200") {
                        window.location.href = res.data.data;
                      } else {
                        Dialog.alert({
                          title: "提示",
                          message: res.data.message,
                        });
                      }
                    });
                  } else if (this.guangdianAuth == true) {
                    this.$router.push('/user/ctccGdAuth');
                  } else if (this.ctccPhoneAuth == true) {
                    this.$router.push('/user/ctccPhoneAuth');
                  } else {
                    window.location.href = this.otherUrl;
                  }
                })
                .catch(() => { });
            }
          });

        }
      }
      );
    },
    loginOut() {
      var loginHtml = localStorage.getItem('loginHtml');
      if (loginHtml === 1) {
        window.location.href = 'http://wx.wzyw.cc/#/user/loginBind/';
      } else if (loginHtml === 2) {
        window.location.href = 'http://wx.wzyw.cc/#/user/';
      } else if (loginHtml === 3) {
        window.location.href = 'http://wx.wzyw.cc/#/userNew/login';
      } else if (loginHtml === 4) {
        window.location.href = 'http://wx.wzyw.cc/#/userNew/loginShe';
      } else {
        window.location.href = 'http://wx.wzyw.cc/#/user/';
      }
    },
    handleClick(row) {
      this.dataToPay = {
        iccid: this.$store.state.iccid,
        soldPackageId: row.id,
        isAdmin: this.isAdmin,
        secondaryId: '',
        primaryId: '',
        salePriceRmb: row.salePriceRmb,
        isNextMonth: this.radio,
        mobile: ''
      }
      this.price = row.salePriceRmb;
      this.isNaturalMonth = row.type == 2 || row.type == 10 || row.type == 14 || row.type == 6 || row.type == 25 || row.type == 17 ? true : false;
      var params = {
        iccid: this.$store.state.iccid,
        pkgId: row.id,
        isAdmin: this.isAdmin,
        isNextMonth: this.isNaturalMonth ? '1' : '0'
      }
      wxRequest("sim/activity/timer/all", params, "post").then(res => {
        if (res.data.code === '200') {
          this.radio = '0'
          this.timeShow = true
          this.nextMonthDay = res.data.data.nextMonthDay
          this.nowMonthDay = res.data.data.nowMonthDay
        } else {
          this.$store.state.showCheckstand = true;
          this.$store.state.showCheckstandSource = 'flowRecharge';
        }
      })
    },
    confirm() {
      this.dataToPay.isNextMonth = this.radio
      this.timeShow = false
      this.$store.state.showCheckstand = true;
      this.$store.state.showCheckstandSource = 'flowRecharge';
    },
    updateStateRateFlow() {
      let fd = new FormData();
      fd.append("iccid", this.$store.state.iccid);
      wxRequest("sim/select/stateRateFlow", fd, "post").then((res) => {

        let second = 3;
        const timer = setInterval(() => {
          second--;
          if (second) {
            Toast.success("刷新成功");
          } else {
            clearInterval(timer);
            // 手动清除 Toast
            Toast.clear();
            this.getUserSimInfo();
          }
        }, 1000);
      });
    },
    toRecharge() {
      // this.$router.push({
      //   path: "/user/balanceRecharge",
      //   query: {
      //     iccid: this.$store.state.iccid,
      //   },
      // });
      // console.log(this.$router)
      this.appshowimg = true;
    },
    toRecharge1() {
      wxRequest(
        "sim/to/active",
        { iccid: localStorage.getItem("iccid") },
        "get"
      ).then((res) => {
        Dialog.alert({ message: res.data.message });
      });
    },
    toRecharge2() {
      wxRequest(
        "sim/to/pause",
        { iccid: localStorage.getItem("iccid") },
        "get"
      ).then((res) => {
        Dialog.alert({ message: res.data.message });
      });
    },

    toLog() {
      this.$router.push({
        path: "/user/balanceRechargeRecord",
        query: {
          iccid: this.$store.state.iccid,
        },
      });
    },
    getDateByTimeStr(timeStr) {
      if (timeStr && typeof timeStr === "string") {
        let dayStr = timeStr.split(" ")[0].split("-");
        let hourStr = timeStr.split(" ")[1].split(":");
        return dayStr.concat(hourStr);
      }
      return timeStr;
    },


  },

  mounted() {
    // this.$store.state.iccid = '89860623530060926213';
    // localStorage.setItem("iccid", '89860623530060926213');
    this.getUserSimInfo();
    wxRequest("sim/user/soldPkg", { iccid: this.$store.state.iccid }, "get").then(res => {
      if (res.data.code === '200') {
        this.isAdmin = res.data.data.isAdmin
        this.thisCucc = res.data.data.list.filter(item => item.type === 17 || item.type === 14).length > 0 ? 1 : 0
        this.dataList = res.data.data.list.sort((b, a) => b.sort - a.sort);
        /**每月倒数第6天默认选中次月生效**/
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var date2 = new Date(year, month + 1, 0)
        var endDay = date2.getDate();
        if (this.thisCucc == 0) {
          day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
        } else {
          if (day >= 21 && day <= 26) {
            this.isNextMonth = '1'
          } else {
            console.log('当前次月' + day);
          }
        }
      }
    })
  },
};
</script>



<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#home {
  height: 100vh;
  background: #f4f5f9;
  overflow: auto;

  a {
    color: #2c3e50;
  }

  .home-top {
    color: #fff;
    height: 120px;
    // background-image: linear-gradient(#2452c8, #fff);
    background: url('../../assets/user/bg.png')no-repeat center;
    background-size: 100% 100%;
    padding-top: 6px;
    position: relative;

    .header {
      background: #fff url('../../assets/user/cardDetailHeardBg.png') no-repeat center;
      background-size: cover;
      margin: 10px;
      padding-bottom: 5px;
      margin-top: 0px;
      box-shadow: 0 0.04rem 0.2rem 0.04rem rgba(13, 72, 145, .1);

      .top {
        padding: 12px 0;
        display: flex;
        align-items: center;

        .top-r {
          .user-name {
            color: #64a9ff;
            font-size: 16px;
          }

          .van-button--small {
            height: 24px;
            padding: 0 14px;
            margin-top: 8px;
          }
        }
      }

      .logo {
        width: 66px;
        height: 66px;
        margin-right: 10px;
        margin-left: 20px;

        img {
          width: 66px;
          height: 66px;
          margin-bottom: 10px;
          border-radius: 35px;
          border: 2px solid #e0eeff;
        }
      }
    }

    .fs-center {
      display: flex;
      margin: 0 16px;
      align-items: center;
      border-bottom: 1px solid #eee;
      height: 50px;

      .van-button--small {
        height: 24px;
        padding: 0 14px;
      }

      .fs-left {
        color: #64a9ff;
        font-size: 14px;
      }

      .divider {
        background-color: #999;
        width: 1px;
        margin: 0 10px;
        height: 14px;
      }

      .fs-meddle {
        font-size: 14px;
        color: green;
        margin-right: 12px;
      }
    }

    .top-taocan {
      display: flex;
      padding: 12px 0;

      .b_r {
        border-right: 1px solid #ddd;
      }

      .taocan-item {
        color: #999;
        font-size: 12px;
        text-align: center;
        flex: 1;

        .time-name {
          margin-top: 8px;
        }

        .time {
          color: #fca842;
          font-size: 16px;
        }
      }
    }
  }

  .menu-nav {
    display: flex;
    margin: 10px;
    background: #fff;

    .left {
      flex: 1;
      text-align: center;
      padding: 10px 0;
      color: #999;
      font-size: 12px;
      /* 确保内容块内元素居中对齐 */
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .menu-icon {
      /* 图标居中显示并去除默认间距 */
      display: block;
      margin: 0 auto 5px;
      /* 底部留一点间距区分图标和文字 */
    }
  }

  .content {
    margin: 10px;

    .content-items {
      margin-bottom: 14px;
      background: #fff;
      border-radius: 10px;
      padding: 13px 16px;

      .items-name {
        font-size: 16px;
        color: #333;
      }

      .items-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;

        .fl_l {
          font-size: 20px;
          color: #fca842;

          span {
            font-size: 14px;
          }
        }

        .van-button--small {
          height: 32px;
          padding: 0 14px;
        }
      }
    }
  }
}

.van-radio {
  justify-content: center;
  margin: 16px 0;

  .van-radio__label {
    span {
      padding-left: 5px;
      color: #969696;
      font-size: 12px;
    }
  }
}

.pkgList {
  margin-top: 30px;
  margin-left: 20px;

  p {
    margin-bottom: 10px;
    color: #999;
  }

  span {
    color: #333;
  }
}
</style>
